export default class LifeConfigurationsHiringAges {
  holderInsured: {
    min: string
    max: string
  }
  insured: {
    min: string
    max: string
  }

  constructor(data?: LifeConfigurationsHiringAges) {
    this.holderInsured = data?.holderInsured ?? { min: '', max: '' }
    this.insured = data?.insured ?? { min: '', max: '' }
  }
}
